<!-- component for listing profiles at admin page -->
<template>
  <div class="sidebar flex flex-column">
    <div class="flex-auto flex flex-column h100 overflow-y">
      <div class="flex-none flex items-center justify-between p2">
        <div class="caps h6 gray-3 semibold">Käyttäjät</div>
        <div class="flex-none">
          <div class="h6 gray-3 semibold">{{allProfiles.filter(p => p.loggedIn).length}}/{{allProfiles.length}}</div>
        </div>
      </div>
      <div class="ml2 mb2">
        <Button @click="addNewUser" variant="primary">Lisää käyttäjä</Button>
      </div>

      <div class="border-bottom border-gray-5 flex-auto overflow-y">
        <ul class="list-reset m0">
          <ProfileListItem v-for="profile in activeProfiles" :profile="profile" :key="profile.userId"></ProfileListItem>
        </ul>
        <div class="flex caps h6 gray-3 semibold pt3 p2 border-top border-gray-5">Poistetut käyttäjät</div>
        <ul class="list-reset m0">
          <ProfileListItem v-for="profile in deactivatedProfiles" :profile="profile" :key="profile.userId"></ProfileListItem>
        </ul>
        <div class="flex items-center p2 border-top border-gray-5"></div>
      </div>
    </div>
  </div>
</template>

<script>

import ProfileListItem from '@/components/ProfileListItem.vue'
import Button from '@/components/Button.vue'
import { mapGetters } from 'vuex';

export default {
  name: 'ProfileList',
  components: {
    ProfileListItem,
    Button,
  },
  computed: {
    ...mapGetters({
      allProfiles: 'allProfiles',
      activeProfiles: 'activeProfiles',
      deactivatedProfiles: 'deactivatedProfiles',
      selectedProfile: 'selectedProfile'
    }),
    someFunction: function () {
      //helper
    }
  },
  methods: {
    addNewUser() {
      this.$store.dispatch('setNewProfile');
    },
  },

  mounted: function () {
    this.$store.dispatch('getAllProfiles');
  }
};
</script>

<style>
  :root {
    --sidebar-border-color: var(--gray-5);
    --sidebar-width: 16rem;
    --sidebar-width-xl: 24rem;
  }
</style>

<style scoped>
  .sidebar {
    flex: none;
    width: var(--sidebar-width);
    color: #003665;
    background-color: #f4f4f4;
  }

  @media (--breakpoint-xl) {
    .sidebar {
      width: var(--sidebar-width-xl);
    }
  }

  @custom-media --breakpoint-xs (max-width: 40em);
  @custom-media --breakpoint-lg (min-width: 64em);
  @custom-media --breakpoint-xl (min-width: 80em);

</style>
